import React, { Suspense, lazy } from 'react'
import { Widget } from '@ally/data-types-customization'
import { Box } from '@ally/metronome-ui'
import WidgetWrapper from './WidgetWrapper'
import { WidgetKey } from './types'
import LoadingSpinner from './Widgets/LoadingSpinner'

const AccountsOverviewWidget = lazy(
  () => import('./Widgets/AccountsOverviewWidget'),
)
const StkWidget = lazy(() => import('./Widgets/StkWidget'))
const TransfersWidget = lazy(() => import('./Widgets/TransfersWidget/Index'))
const BadgeWidget = lazy(() => import('./Widgets/BadgeWidget'))
const WeeklyFinancialInsightsWidget = lazy(
  () => import('./Widgets/WeeklyFinancialInsightsWidget'),
)

const widgetMap: Record<WidgetKey, React.FC> = {
  accountsOverviewWidget: AccountsOverviewWidget,
  stkWidget: StkWidget,
  transfersWidget: TransfersWidget,
  weeklyFinancialInsightsWidget: WeeklyFinancialInsightsWidget,
  badgeWidget: BadgeWidget,
}

export function getWidgetContainer(
  isCustomizationEnabled: boolean,
  widgets: Widget[],
): JSX.Element | null {
  if (!isCustomizationEnabled || widgets.length < 1) {
    return null
  }

  return (
    <>
      {widgets
        .filter(widget => widget.enabled)
        .map(widget => {
          const WidgetComponent = widgetMap[widget.name as WidgetKey]
          return (
            WidgetComponent && (
              <WidgetWrapper key={widget.name}>
                <Suspense
                  fallback={
                    <Box display="flex" height="200px">
                      <LoadingSpinner />
                    </Box>
                  }
                >
                  <WidgetComponent />
                </Suspense>
              </WidgetWrapper>
            )
          )
        })}
    </>
  )
}
